import { LoadingOutlined } from "@ant-design/icons"
import { Card } from "antd"

const PageLoading = ({ message = 'Đang tải...' }: { message?: string }) => {
    return (
        <div className='global-page-loading'>
            <Card size='small'>
                <LoadingOutlined /> {message}
            </Card>
        </div>
    )
}

export default PageLoading